/**
 * Remove all non-numeric characters from a string
 * @param input - Input string
 * @returns String containing only digits
 */
export const parseDigits = (input: string): string => {
  return input.replace(/\D/g, '');
};

export const removeDDIFromAutoInsert = (phone: string): string => {
  const digits = parseDigits(phone);
  if (digits.startsWith('55') && digits.length > 11) {
    return digits.slice(2);
  }
  return digits;
};

export const addDDIToPhone = (phone: string): string => {
  const digits = parseDigits(phone);
  if (digits.length === 11) {
    return `55${digits}`;
  }
  return digits;
};

/**
 * Format a number as Brazilian currency (BRL)
 * @param value - Numeric value to be formatted
 * @returns String formatted as Brazilian currency
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Adiciona zero à esquerda para números menores que 10
 * @param time - Número a ser formatado
 * @returns String formatada com zero à esquerda se necessário
 */
export const padZero = (time: number): string => {
  return time.toString().padStart(2, '0');
};

/**
 * Format date and time in Brazilian standard
 * @param date - Date as Date object or string
 * @returns String formatted as "DD/MM/YYYY - HH:MM"
 */
export const formatDateTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const formattedDate = dateObj.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  const formattedTime = dateObj.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${formattedDate} - ${formattedTime}`;
};

/**
 * Format a number with dots as thousands separator
 * @param value - Number to be formatted
 * @returns String formatted with dots as thousands separator
 */
export const formatNumberWithDots = (value: number): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
